import React from 'react';
import {css} from 'emotion';
import Switch from '../../common/material-easy-ui/input/Switch';
const CguAccept = (props) =>{
  return(
    <div className={css`display:flex;margin-top:20px;align-items:center`}>
      <div className={css`flex:1;font-size:13px`}>
        <div>
            <div>je confirme avoir lu et accepté les</div>
            <div className={css`text-decoration:underline`}>Condition Génerales d'utilisation de l'application
            </div>
        </div>
      </div>
      <div>
      <Switch
        isOn={props.value}
        onColor="#0084C6"
        handleToggle={props.onAccept}
      />
      </div>

    </div>
  )
}

export default CguAccept;
